import React from 'react'
import './style.sass'
import PropTypes from 'prop-types'
import deleteIcon from '../../../../assets/icons/delete.svg'
import FieldWrapper from '../FieldWrapper'

const TextFieldWithDelete = ({ type = "text" , displayName, placeholder, description, errorMessage, disabled, value, onChange, onDeletedClicked }) => {
  return (
    <FieldWrapper
      displayName={displayName}
      description={description} 
      errorMessage={errorMessage}
      disabled={disabled}
    >
      <div className="text-field-with-delete-container">
        <input
          type={type}
          placeholder={placeholder || displayName}
          value={value ?? ""}
          onChange={onChange ? (e) => onChange(e.target.value) : () => {}}
          disabled={disabled}
        />
        {!disabled ? (
          <div 
            className='delete-btn' 
            onClick={onDeletedClicked ? () => onDeletedClicked() : () => {}}
          >
            <img src={deleteIcon} alt='delete' />
          </div>
        ) : null} 
      </div>
    </FieldWrapper>
  )
}

TextFieldWithDelete.propTypes = {
  type: PropTypes.oneOf(['text', 'email', 'number', 'password']),
  displayName: PropTypes.string,
  placeholder: PropTypes.string,
  description: PropTypes.string,
  errorMessage: PropTypes.string,
  disabled: PropTypes.bool,
  value: PropTypes.any,
  onChange: PropTypes.func,
}

export default TextFieldWithDelete
